import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledNotificationBubble = styled(Box)<{ hasNotifications: boolean }>(({ hasNotifications }) => ({
  position: "absolute",
  borderRadius: "50%",
  background: hasNotifications ? "#F35053" : "transparent",
  width: "16px",
  height: "16px",
  insetInlineEnd: "0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "10px",
  color: "white",
  top: "-6px",
  right: "-2px",
  cursor: "pointer",
}));
export default StyledNotificationBubble;
